import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';

interface Params {
    enterpriseId: string;
    filteredRateGroupId: string;
    serviceId: string;
}
export const useRateOptions = ({ enterpriseId, filteredRateGroupId, serviceId }: Params) =>
    useRepositoryQuery(
        'rates',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            serviceIds: [serviceId],
        },
        {
            select: ({ rates }) =>
                rates
                    ? pipe(
                          rates,
                          array.filterMap(({ id, name, rateGroupId }) =>
                              rateGroupId === filteredRateGroupId
                                  ? option.some(createOption({ value: id, label: name }))
                                  : option.none
                          )
                      )
                    : [],
        }
    );
